import { render, staticRenderFns } from "./training-search.vue?vue&type=template&id=7dc44963&"
import script from "./training-search.vue?vue&type=script&lang=js&"
export * from "./training-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports